import React, { useState } from 'react';
import {
  Fab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Alert
} from '@mui/material';
import { Feedback as FeedbackIcon } from '@mui/icons-material';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { useAuth } from '../../contexts/AuthContext';

export default function FeedbackWidget() {
  const [open, setOpen] = useState(false);
  const [feedbackType, setFeedbackType] = useState(null);
  const [feedback, setFeedback] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user } = useAuth();

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await addDoc(collection(db, 'feedback'), {
        type: feedbackType,
        feedback: feedback,
        email: user?.email || 'anonymous',
        date: new Date().toISOString(),
        userId: user?.uid || 'anonymous'
      });

      setShowSuccess(true);
      setTimeout(() => {
        setOpen(false);
        setShowSuccess(false);
        setFeedback('');
        setFeedbackType(null);
      }, 3000);
    } catch (error) {
      console.error('Error submitting feedback:', error);
    }
    setIsSubmitting(false);
  };

  return (
    <>
      <Fab
        color="primary"
        aria-label="feedback"
        onClick={() => setOpen(true)}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
        }}  
      >
        <FeedbackIcon />
      </Fab>

      <Dialog open={open} onClose={() => !isSubmitting && setOpen(false)} sx={{
    '& .MuiPaper-root': {
      width: '600px', // Specify the width
      height: '400px', // Specify the height
      maxWidth: '100%', // Ensure it doesn't exceed the screen size
      maxHeight: '100%', // Ensure it doesn't exceed the screen size
    },
  }}>
        <DialogTitle>
          {!feedbackType ? 'Share Your Feedback' : 
           feedbackType === 'bug' ? 'Report a Bug' : 'Request a Feature'}
        </DialogTitle>
        <DialogContent>
          {showSuccess ? (
            <Box
            sx={{
              display: 'flex', // Ensure proper layout
              justifyContent: 'center', // Center horizontally
              alignItems: 'center', // Center vertically
              width: '100%', // Make sure the container spans the available space
              height: '50px', // Make sure the container spans the available space
            }}
          >
            <Alert severity="success" sx={{
                display: 'flex', // Ensure content aligns correctly
                alignItems: 'center', // Center content vertically
                
                textAlign: 'center', // Optional: Align text in the center
                padding: '16px', // Adjust padding if needed
                boxSizing: 'border-box', // Ensure padding doesn't affect dimensions
              }}>
              {feedbackType === 'bug' 
                ? 'We appreciate you reporting the bug, we will address it soon.'
                : 'Thanks for proposing new features, we will definitely consider it.'}
            </Alert>
            </Box>
          ) : (
            <>
              {!feedbackType ? (
                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => setFeedbackType('bug')}
                  >
                    Report a Bug
                  </Button>
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => setFeedbackType('feature')}
                  >
                    Request a Feature
                  </Button>
                </Box>
              ) : (
                <TextField
                  autoFocus
                  margin="dense"
                  label={feedbackType === 'bug' ? 'Describe the bug' : 'Describe the feature'}
                  fullWidth
                  multiline
                  rows={8}
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  disabled={isSubmitting}
                />
              )}
            </>
          )}
        </DialogContent>
        {feedbackType && !showSuccess && (
          <DialogActions>
            <Button 
              onClick={() => setFeedbackType(null)} 
              disabled={isSubmitting}
            >
              Back
            </Button>
            <Button 
              onClick={handleSubmit} 
              variant="contained"
              disabled={!feedback.trim() || isSubmitting}
            >
              Submit
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
}
